if (!customElements.get('real-support')) {
  class RealSupport extends HTMLElement {
    constructor() {
      super();

      this.init();
    }

    init() {
      this.stepsWrapper = document.getElementById("RealSupportSteps");
      this.searchButton = document.getElementById("RealSupportSearch");
      this.result = {
        blogs: {
          content: document.getElementById("RealSupportResultBlogs"),
          items: document.getElementById("RealSupportResultBlogsItems"),
          pagination: document.getElementById("RealSupportResultBlogsPagination")
        },
        products: {
          content: document.getElementById("RealSupportResultProducts"),
          items: document.getElementById("RealSupportResultProductsItems"),
          pagination: document.getElementById("RealSupportResultProductsPagination")
        }
      };

      this.switches = {
        blogs: document.getElementById("RealSupportResultBlogs"),
        products: document.getElementById("RealSupportResultProducts"),
        blogsSwitch: document.getElementById("RealSupportSearchBlogs"),
        productsSwitch: document.getElementById("RealSupportSearchProduct")
      };

      this.searchButton.addEventListener("click", () => {
        this.searchEvent("blogs", this.createSearchURL('page,article'), 1);
        this.searchEvent("products", this.createSearchURL('product')), 1;
      });
      this.searchEvent("blogs", this.createSearchURL('page,article'), 1, false);
      this.searchEvent("products", this.createSearchURL('product'), 1, false);

      document.addEventListener("click", (e) => {
        if (e.target && e.target.hasAttribute('data-href') && e.target.classList.contains("pagination__item--blogs")) {
          let href = e.target.dataset.href;
          let page = e.target.dataset.page;
          this.searchEvent("blogs", decodeURIComponent(href), page);
        }
        if (e.target && e.target.hasAttribute('data-href') && e.target.classList.contains("pagination__item--products")) {
          let href = e.target.dataset.href;
          let page = e.target.dataset.page;
          this.searchEvent("products", decodeURIComponent(href), page);
        }
      });

      this.switchSelect();
    }

    createBlogsContent(resultObject, searchURL, pageID, scrollToSection) {
      this.result.blogs.items.innerHTML = decodeURIComponent(resultObject.results);

      let pageCount = Math.ceil(resultObject.results_count / 6);
      this.result.blogs.pagination.innerHTML = this.createPagination("blogs", searchURL, pageID, pageCount);
      if (scrollToSection)
        this.result.blogs.items.scrollIntoView(true);
    }

    decodeEntities(encodedString) {
      var textArea = document.createElement('textarea');
      textArea.innerHTML = encodedString;
      return textArea.value;
    }

    createPagination(type, searchURL, pageID, pageCount) {
      let paginationContent = `<nav class="pagination" role="navigation" aria-label="Pagination">
        <ul class="pagination__list list-unstyled" role="list">`;
      let intPageID = parseInt(pageID);
      if (intPageID - 1 > 0) {
        paginationContent += `
          <li>
            <a data-href="${ encodeURIComponent(searchURL) }" data-page="${ intPageID - 1 }" class="pagination__item--${ type } pagination__item pagination__item--next pagination__item-arrow link motion-reduce" aria-label="Previous page">
              <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
              </path></svg>
            </a>
          </li>
        `;
      }
      if (pageCount < 8) {
        for (let i = 1; i <= pageCount; i++) {
          let paginationButton = "";
          if (i === intPageID) {
            paginationButton = `
              <li>
                <a role="link" aria-disabled="true" class="pagination__item--${ type } pagination__item pagination__item--current light" aria-current="page" aria-label="Page ${ i }">
                  ${ i }
                </a>
              </li>
            `;
          } else {
            paginationButton = `
              <li>
                <a data-href="${ encodeURIComponent(searchURL) }" data-page="${ i }" class="pagination__item--${ type } pagination__item link" aria-label="Page ${ i }">
                  ${ i }
                </a>
              </li>
            `;
          }
          paginationContent += paginationButton;
        }
      } else {
        const pagesToDisplay = [1, intPageID - 2, intPageID - 1, intPageID, intPageID + 1, intPageID + 2, pageCount];

        for (let i = 1; i <= pageCount; i++) {
          if ((i === intPageID - 3 || i === intPageID + 3) && i !== 1 && i !== pageCount) {
            paginationContent += `
              <li><span class="pagination__item">…</span></li>
            `;
          }
          if (!pagesToDisplay.includes(i)) {
            continue;
          }
          let paginationButton = "";
          if (i === intPageID) {
            paginationButton = `
              <li>
                <a role="link" aria-disabled="true" class="pagination__item--${ type } pagination__item pagination__item--current light" aria-current="page" aria-label="Page ${ i }">
                  ${ i }
                </a>
              </li>
            `;
          } else {
            paginationButton = `
              <li>
                <a data-href="${ encodeURIComponent(searchURL) }" data-page="${ i }" class="pagination__item--${ type } pagination__item link" aria-label="Page ${ i }">
                  ${ i }
                </a>
              </li>
            `;
          }
          paginationContent += paginationButton;
        }
      }

      if (intPageID + 1 <= pageCount) {
        paginationContent += `
          <li>
            <a data-href="${ encodeURIComponent(searchURL) }" data-page="${ intPageID + 1 }" class="pagination__item--${ type } pagination__item pagination__item--prev pagination__item-arrow link motion-reduce" aria-label="Next page">
              <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
              </path></svg>
            </a>
          </li>
        `;
      }

      paginationContent += `</ul></nav>`;
      return paginationContent;
    }

    createProductsContent(resultObject, searchURL, pageID, scrollToSection) {
      this.result.products.items.innerHTML = this.decodeEntities(resultObject.results);

      let pageCount = Math.ceil(resultObject.results_count / 6);
      this.result.products.pagination.innerHTML = this.createPagination("products", searchURL, pageID, pageCount);
      if (scrollToSection)
        this.result.products.items.scrollIntoView(true);
    }

    switchSelect() {
      this.switches.blogsSwitch.addEventListener("click", () => {
        this.switches.blogsSwitch.classList.add("active");
        this.switches.productsSwitch.classList.remove("active");
        this.switches.blogs.classList.add("active");
        this.switches.products.classList.remove("active");
      });
      this.switches.productsSwitch.addEventListener("click", () => {
        this.switches.blogsSwitch.classList.remove("active");
        this.switches.productsSwitch.classList.add("active");
        this.switches.blogs.classList.remove("active");
        this.switches.products.classList.add("active");
      });
    }

    searchPhrase(checkbox) {
      let phrase = "";
      if (checkbox.dataset.searchType === "and") {
        phrase = '"' + checkbox.value + '"';
      } else if (checkbox.dataset.searchType === "or") {
        phrase = checkbox.value.replace(/ /g, " OR ");
      } else {
        phrase = '"' + checkbox.value + '"';
      }
      return(phrase);
    }

    createSearchURL(type) {
      let options = {
        "steps1": [],
        "steps2": [],
        "steps3": []
      };
      let checkboxes = this.stepsWrapper.querySelectorAll("input:checked");

      checkboxes.forEach(checkbox => {
        if (checkbox.dataset.step === "0") {
          options.steps1.push(this.searchPhrase(checkbox));
        } else if (checkbox.dataset.step === "1") {
          options.steps2.push(this.searchPhrase(checkbox));
        } else {
          options.steps3.push(this.searchPhrase(checkbox));
        }
      });

      let searchArray = [];
      if (options.steps1.length > 0)
        searchArray.push(options.steps1.join(' OR '));
      if (options.steps2.length > 0)
        searchArray.push(options.steps2.join(' OR '));
      if (options.steps3.length > 0)
        searchArray.push(options.steps3.join(' OR '));

      return '/search?type=' + type + '&q=' +
        searchArray.join(" AND ") + " -IRHIDE" +
        '&view=jsonType';
    }

    searchEvent(type, searchURL, pageID = 1, scrollToSection = true) {
      if (type === "blogs")
        fetch(searchURL + "&page=" + pageID)
          .then(res => res.json())
          .then(object => this.createBlogsContent(object, searchURL, pageID, scrollToSection));
      else
        fetch(searchURL + "&page=" + pageID)
          .then(res => res.json())
          .then(object => this.createProductsContent(object, searchURL, pageID, scrollToSection));
    }
  }

  customElements.define('real-support', RealSupport);
}
